(() => {
  'use strict';
  if (window.NiralaFloatingActions) {
    window.NiralaFloatingActions.init();
    return;
  }

  const instances = new Map();
  let frame = 0;
  let observer = null;
  let started = false;

  function otherDialogOpen(current) {
    return [...document.querySelectorAll('dialog[open]')].some(dialog => dialog !== current);
  }
  function sync() {
    frame = 0;
    const anyDialog = Boolean(document.querySelector('dialog[open]'));
    instances.forEach(instance => {
      if (!instance.root.isConnected) {
        instance.destroy();
        instances.delete(instance.root);
        return;
      }
      if (instance.dialog?.open && otherDialogOpen(instance.dialog)) instance.dialog.close();
      instance.controls.hidden = anyDialog;
      instance.buttons.forEach(button => { button.disabled = anyDialog; });
      if (instance.top) instance.top.hidden = window.scrollY < instance.threshold;
      instance.search?.setAttribute('aria-expanded', String(Boolean(instance.dialog?.open)));
    });
  }
  function scheduleSync() {
    if (!frame) frame = window.requestAnimationFrame(sync);
  }
  function create(root) {
    const controls = root.querySelector('[data-floating-controls]');
    if (!controls) return;
    const dialog = root.querySelector('[data-floating-search-dialog]');
    const search = root.querySelector('[data-floating-search-open]');
    const input = root.querySelector('[data-floating-search-input]');
    const top = root.querySelector('[data-floating-top]');
    let returnFocus = null;

    const onClose = () => {
      sync();
      if (returnFocus?.isConnected && !otherDialogOpen(dialog)) returnFocus.focus({ preventScroll: true });
      returnFocus = null;
    };
    const onClick = event => {
      if (event.target.closest('[data-floating-search-open]')) {
        if (!dialog || otherDialogOpen(dialog) || dialog.open) return;
        if (typeof dialog.showModal !== 'function') {
          window.location.assign(root.dataset.searchUrl);
          return;
        }
        returnFocus = search;
        dialog.showModal();
        sync();
        // Focus only follows this explicit visitor click, never page load/editor refresh.
        input?.focus({ preventScroll: true });
      } else if (event.target.closest('[data-floating-search-close]')) {
        if (dialog?.open) dialog.close();
      } else if (event.target.closest('[data-floating-top]')) {
        if (document.querySelector('dialog[open]')) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        document.getElementById('MainContent')?.focus({ preventScroll: true });
        window.scrollTo({ top: 0, left: 0, behavior: reduced ? 'auto' : 'smooth' });
      } else if (dialog && event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    };
    root.addEventListener('click', onClick);
    dialog?.addEventListener('close', onClose);
    const instance = {
      root, controls, dialog, search, top,
      buttons: [...controls.querySelectorAll('button')],
      threshold: Math.max(0, Number(root.dataset.topThreshold) || 400),
      destroy() {
        root.removeEventListener('click', onClick);
        dialog?.removeEventListener('close', onClose);
        if (dialog?.open) dialog.close();
        returnFocus = null;
      }
    };
    instances.set(root, instance);
  }
  function init() {
    if (!document.body) return;
    document.querySelectorAll('[data-floating-actions]').forEach(root => {
      if (!instances.has(root)) create(root);
    });
    if (!started) {
      started = true;
      window.addEventListener('scroll', scheduleSync, { passive: true });
      window.addEventListener('pageshow', scheduleSync);
      document.addEventListener('close', scheduleSync, true);
      document.addEventListener('cancel', scheduleSync, true);
      document.addEventListener('shopify:section:load', init);
      document.addEventListener('shopify:section:unload', scheduleSync);
      observer = new MutationObserver(scheduleSync);
      observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    }
    sync();
  }

  window.NiralaFloatingActions = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
